import React from 'react';
import './Button.css';

/**
 * Glacier button primitive.
 *
 * Variants:
 *  - primary  46h, warning yellow — top-level CTA
 *  - ghost    38h, translucent glass — secondary
 *  - compact  38h auto-width, warning yellow — inline action
 *  - icon     38×38 square, glass — icon-only; aria-label required
 */
const Button = React.forwardRef(function Button(
  {
    variant = 'primary',
    type = 'button',
    onClick,
    disabled = false,
    className = '',
    children,
    ...rest
  },
  ref,
) {
  const variantClass = `btn--${variant}`;
  const composed = `btn ${variantClass}${className ? ` ${className}` : ''}`;

  return (
    <button
      ref={ref}
      type={type}
      className={composed}
      onClick={onClick}
      disabled={disabled}
      data-variant={variant}
      {...rest}
    >
      {children}
    </button>
  );
});

export default Button;
